import { render, staticRenderFns } from "./LanguageButton.vue?vue&type=template&id=5b442ee0&scoped=true"
import script from "./LanguageButton.vue?vue&type=script&lang=js"
export * from "./LanguageButton.vue?vue&type=script&lang=js"
import style0 from "./LanguageButton.vue?vue&type=style&index=0&id=5b442ee0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b442ee0",
  null
  
)

export default component.exports